<template>
  <div style="border: 1px solid #ccc;">
    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor style="height: 500px; overflow-y: hidden;" v-model="html" :defaultConfig="editorConfig" :mode="mode"
      @onCreated="onCreated" />
  </div>
</template>
<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
//import { DomEditor } from '@wangeditor/editor'
export default {
  name: 'dyh-wangEditor',
  components: { Editor, Toolbar },
  data() {
    return {
      editor: null,
      html: "",
      toolbarConfig: {
        excludeKeys: [
          'insertVideo',
          'fullScreen',
          'emotion',
          'group-video',
          'group-image'
        ]
      },
      editorConfig: {
        placeholder: '请输入内容...'
      },
      mode: 'default' // or 'simple'
    }
  },
  watch: {
    html(n, o) {
      this.$emit('wangEditorChange', n)
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    setHtml(html) {
      const that = this;
      setTimeout(() => {
        that.html = html;
      }, 1000)
    }
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    /* setTimeout(() => {
      this.html = '<p>请输入商品详细描述</p>'
    }, 1500); */
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>